import type { FC } from 'react';
import { Snackbar, SnackbarButton, SnackbarItem } from '@george-labs.com/design-system';
import classNames from 'classnames';

import styles from './SnackbarContainer.module.scss';
import { useNotificationsState } from './useNotificationsState';

type Props = {
    offsetSize?: 'sm' | 'lg' | 'none';
};

export const SnackbarContainer: FC<Props> = ({ offsetSize = 'sm' }) => {
    const {
        items,
        dispatchActions: { removeItem },
    } = useNotificationsState();

    function getSnackbarOffsetClassName() {
        if (offsetSize === 'sm') {
            return styles.snackbarOffsetSm;
        }
        if (offsetSize === 'none') {
            return styles.snackbarOffsetNone;
        }
        return styles.snackbarOffsetLg;
    }

    return (
        <Snackbar
            className={classNames(getSnackbarOffsetClassName(), 'd-print-none')}
            data-cy="snackbar-container"
        >
            {items?.map((item) => {
                const button = item.buttonProps ? (
                    <SnackbarButton
                        onClick={item.buttonProps.onClick}
                        data-cy={item.buttonProps['data-cy']}
                    >
                        {item.buttonProps.child}
                    </SnackbarButton>
                ) : undefined;

                return (
                    <SnackbarItem
                        key={item.id}
                        autoCloseable={item.autoCloseable}
                        variant={item.type}
                        message={item.message}
                        button={button}
                        onClose={() => removeItem(item.id)}
                        data-cy={item['data-cy'] ?? 'snackbar-item'}
                    >
                        {item.message}
                    </SnackbarItem>
                );
            })}
        </Snackbar>
    );
};
